













































































import moment from 'moment';
import { EvtEvent } from 'gl-ms-events';
import { TriTrip } from 'gl-ms-trips';
import events, { eventUpdateRequest } from '@/services/events';
import trips from '@/services/trips';
import { datetimeToTimezone } from '@/helpers';
import eventInfo from '@/components/timeline/eventInfo.vue';

export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time: Date) {
                    return time.getTime() > Date.now();
                },
            },
            validationErrorMessage: '',
            isEventUpdating: false,
            isFormSubmitted: false,
            formSubmittedText: '',
            tripEvents: [],
            currentEvent: undefined,
            triTrip: undefined,
            timelineForm: {
                eventDate: moment().format('yyyy-MM-DD'),
                eventTime: '',
            },
        };
    },
    components: {
        eventInfo,
    },
    async mounted(this: any) {
        this.tripEvents = await this.getTripEvents();
        this.currentEvent = this.getTripEventByUniqueKey;
        if (this.currentEvent) {
            const eventDatetime = this.currentEvent.datetime;
            if (eventDatetime) {
                this.timelineForm = {
                    eventDate: moment(eventDatetime).format('yyyy-MM-DD'),
                    eventTime: '',
                };
            }
            this.triTrip = await this.getTriTrip();
        }
    },
    computed: {
        idTrip(this: any) {
            return String(this.$route.query.id_trip);
        },
        uniqueKey(this: any) {
            return String(this.$route.query.unique_key);
        },
        getTripEventByUniqueKey(this: any) {
            if (this.tripEvents && this.tripEvents.length > 0) {
                const item = this.tripEvents.find((q: EvtEvent) => q.unique_key === this.uniqueKey);
                return item;
            }
            return undefined;
        },
    },
    methods: {
        async confirmEvent(this: any) {
            if (!this.timelineForm.eventDate || !this.timelineForm.eventTime) {
                this.validationErrorMessage = this.$t('timeline.confirmDatetimeRequired');
                return;
            }

            if (this.currentEvent) {
                const eventTimezone = this.currentEvent.timezone;
                const confirmDatetime = `${this.timelineForm.eventDate} ${this.timelineForm.eventTime}:00`;
                const dateWithTimeZone = datetimeToTimezone(confirmDatetime, eventTimezone);
                if (moment(dateWithTimeZone).utc() > moment().utc()) {
                    this.validationErrorMessage = this.$t('timeline.actualDateValidationAlert');
                } else {
                    this.validationErrorMessage = '';
                    this.showActualDateValidationMessage = false;
                    this.isEventUpdating = true;
                    const requestData: eventUpdateRequest = {
                        unique_key: this.uniqueKey,
                        datetime: moment(dateWithTimeZone).utc().format(),
                    };
                    let responseData;
                    try {
                        responseData = await events.updateEvent(this.uniqueKey, requestData);
                        this.isFormSubmitted = true;
                        this.formSubmittedText = this.$t('timeline.formSubmittedText');
                    } catch (err) {
                        const errorData = err.response.data;
                        this.isFormSubmitted = false;
                        if (errorData) {
                            const errorCode = errorData.detailedErrorMessage.code;
                            this.validationErrorMessage = (errorCode ? this.$t(`timelineValidationError.${errorCode}`) : errorData.message);
                        }
                    }
                    this.isEventUpdating = false;
                }
            }
        },
        async getTripEvents(this: any): Promise<EvtEvent[] | undefined> {
            if (!this.idTrip) return undefined;

            const items: EvtEvent[] = await events.eventsByTrip(this.idTrip);
            return items;
        },
        async getTriTrip(this: any): Promise<TriTrip | undefined> {
            if (!this.idTrip) return undefined;

            const item: TriTrip = await trips.getTriTrip(this.idTrip);
            return item;
        },

    },
};
